import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';

import {Field, reduxForm, SubmissionError} from 'redux-form';

import {FormattedMessage} from 'react-intl';
import Button from '../button/Button';
import FieldText from '../fields/fieldText/FieldText';
import ChannelPrice from '../../containers/channelUtils/ChannelPrice';
import Tooltip from '../tooltip/Tooltip';

@injectIntl
@reduxForm({
  form: 'checkoutWallet'
})
export default class CheckoutWalletForm extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      openTooltip: false
    };
  }

  submitHandler = ({funds}) => {
    const {available, max, onSubmit} = this.props;

    funds = parseFloat(funds);

    if (Number.isNaN(funds) || funds <= 0) {
      throw new SubmissionError({});
    }

    funds = Math.floor(funds * (10 ** 2)); // FIXME

    if (funds > available) {
      throw new SubmissionError({funds: <FormattedMessage id="page.checkout.wallet.insufficient"/>})
    }

    if (funds > max) {
      throw new SubmissionError({funds: <FormattedMessage id="page.checkout.wallet.exceeds"/>})
    }

    if (funds > max) {
      funds = max;
    }

    return onSubmit({funds});
  };

  render() {
    const {intl, available, couponActived, submitting, handleSubmit} = this.props;

    return (
      <React.Fragment>
        <div className='checkout__wallet__available'>
          <FormattedMessage
            id="page.checkout.wallet.available"
            values={{amount: <ChannelPrice component="b" price={available}/>}}
          />

          <Tooltip
            content={couponActived ? (
              <FormattedMessage id="page.checkout.wallet.walled-disabled" />
            ) : (
              <FormattedMessage id="page.checkout.wallet.tooltip" />
            )}
            open={this.state.openTooltip}
          >
            <div className='tooltip_trigger' onMouseLeave={() => this.setState({openTooltip: false})} onMouseEnter={() => this.setState({openTooltip: true})} />
          </Tooltip>
        </div>

        <form className='checkout__wallet__form' onSubmit={handleSubmit(this.submitHandler)}>
          <Field
            name="funds"
            type="number"
            step="any"
            placeholder={intl.formatMessage({id: 'page.checkout.wallet.placeholder'})}
            component={FieldText}
            disabled={couponActived}
          >
          </Field>

          <Button
            filled
            loading={submitting}
            disabled={couponActived || submitting}
            mod="checkout"
            >
            <FormattedMessage id="page.checkout.wallet.submit"/>
          </Button>
        </form>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./components/checkout/CheckoutWalletForm.js